
async function apiLoginUser(email, password) {
  const response = await fetch('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, password })
  })
  const data = await response.json()
  if (data.status != 'OK') {
    throw new Error(data.data)
  }
  localStorage.setItem('token', data.data)
}

async function apiCheckUser() {
  const response = await fetch('/api/auth/check', { 
    headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }})
  const data = await response.json()
  if (data.status == 'OK') {
    return true
  } else {
    return false
  }
}

// Articles

async function apiGetAllArticles() {
  const response = await fetch('/api/articles/all')
  const data = await response.json()
  if (data.status == 'OK') {
    return data.data
  } else {
    throw new Error(data.data)
  }
}

async function apiGetArticle(id) {
  const response = await fetch(`/api/articles/one?id=${id}`)
  const data = await response.json()
  if (data.status == 'OK') {
    return data.data
  } else {
    throw new Error(data.data)
  }
}

async function apiUpdateArticle(article) {
  const response = await fetch(`/api/articles/update`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    body: article
  })
  const data = await response.json()
  if (data.status == 'OK') {
    return true
  } else {
    throw new Error(data.data)
  }
}

async function apiUploadArticleImage(formData) {
  const response = await fetch(`/api/articles/upload-image`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
    body: formData
  })
  const data = await response.json()
  if (data.status == 'OK') {
    return data.data
  } else {
    throw new Error(data.data)
  }
}

// Models
async function apiDeleteModel(id) {
  const response = await fetch(`/api/models/delete?id=${id}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  })
  const data = await response.json()
  if (data.status == 'OK') {
    return true
  } else {
    throw new Error(data.data)
  }
}

async function apiUploadModelImage(formData) {
  const response = await fetch(`/api/models/upload-image`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
    body: formData
  })
  const data = await response.json()
  if (data.status == 'OK') {
    return data.data
  } else {
    throw new Error(data.data)
  }
}

async function apiGetModel(id) {
  const response = await fetch(`/api/models/one?id=${id}`)
  const data = await response.json()
  if (data.status == 'OK') {
    return data.data
  } else {
    throw new Error(data.data)
  }
}

async function apiGetModels(page, gender) {
  const response = await fetch(`/api/models/some?page=${page}&gender=${gender}`, { 
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
  }})
  const data = await response.json()
  if (data.status == 'OK') {
    return data.data
  } else {
    throw new Error(data.data)
  }
}

async function apiUploadModel(model, id) {
  const response = await fetch(`/api/models/upload?id=${id}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    body: model
  })
  const data = await response.json()
  if (data.status == 'OK') {
    return true
  } else {
    throw new Error(data.data)
  }
}

// Requests

async function apiUploadRequest(formData) {
  const response = await fetch('/api/requests/upload', {
    method: 'POST',
    body: formData
  })
  const data = await response.json()
  if (data.status == 'OK') {
    return true
  } else {
    throw new Error(data.data)
  }
}

async function apiGetRequests(page, sort) {
  const response = await fetch(`/api/requests/some?page=${page}&sort=${sort}`, { 
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
  }})
  const data = await response.json()
  if (data.status == 'OK') {
    return data.data
  } else {
    throw new Error(data.data)
  }
}

async function apiGetRequest(id) {
  const response = await fetch(`/api/requests/one?id=${id}`, { 
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
  }})
  const data = await response.json()
  if (data.status == 'OK') {
    return data.data
  } else {
    throw new Error(data.data)
  }
}

async function apiRejectRequest(id) {
  const response = await fetch(`/api/requests/reject?id=${id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
  }})
  const data = await response.json()
  if (data.status == 'OK') {
    return true
  } else {
    throw new Error(data.data)
  }
}

async function apiSeeRequest(id) {
  const response = await fetch(`/api/requests/seen?id=${id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
  }})
  const data = await response.json()
  if (data.status == 'OK') {
    return true
  } else {
    throw new Error(data.data)
  }
}

export {
  apiLoginUser,
  apiCheckUser,
  apiGetAllArticles,
  apiGetArticle,
  apiUploadRequest,
  apiGetRequests,
  apiRejectRequest,
  apiSeeRequest,
  apiGetRequest,
  apiUpdateArticle,
  apiUploadArticleImage,
  apiGetModel,
  apiUploadModelImage,
  apiGetModels,
  apiUploadModel,
  apiDeleteModel
}